import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { Icon } from 'iovisit-theme/components';
import {
  PageHeader,
  InfoBox,
  ViewBlocks,
  Booking,
  hasBooking,
  DownloadButton,
  hasDownload,
  RelatedItems,
  PageMetadata,
} from 'iovisit-theme/components/Views';

import DayExpanded from 'iovisit-theme/components/Views/Itinerary/DayExpanded';
import DayCollapsed from 'iovisit-theme/components/Views/Itinerary/DayCollapsed';
import SummaryInfos from 'iovisit-theme/components/Views/Itinerary/SummaryInfos';

const messages = defineMessages({
  transport_methods: {
    id: 'itinerary_transport_methods',
    defaultMessage: 'Trasporti',
  },
  brochure: {
    id: 'itinerary_brochure',
    defaultMessage: 'Scarica la brochure',
  },
  possible_destinations: {
    id: 'itinerary_possible_destinations',
    defaultMessage: 'Altri posti da visitare',
  },
});

const ItineraryView = ({ content, location }) => {
  const intl = useIntl();
  const days = content.items?.filter((i) => i['@type'] === 'ItineraryDay');

  return (
    <div id="page-itinerary" className="ui container">
      <SummaryInfos content={content} />

      <PageHeader content={{ ...content, show_share_links: true }} />

      {/* INFO BOX */}
      {(content.transport_methods?.length > 0 ||
        hasBooking(content) ||
        hasDownload(content.brochure) ||
        content.brochure?.download) && (
        <InfoBox>
          {content.transport_methods && (
            <>
              <h3>{intl.formatMessage(messages.transport_methods)}</h3>
              <div className="icons-list">
                {content.transport_methods.map((method) => (
                  <span title={method.title} key={method.token}>
                    <Icon icon={method.token} className="icon" />
                  </span>
                ))}
              </div>
            </>
          )}

          <Booking content={content} />

          <DownloadButton
            file={content.brochure}
            title={intl.formatMessage(messages.brochure)}
          />
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      {/* GIORNATE ITINERARIO */}

      {days?.length === 1 && <DayExpanded day={days[0]} />}
      {days?.length > 1 &&
        days.map((day, index) => (
          <>
            <DayCollapsed day={day} key={`day${index}`} />
          </>
        ))}

      <RelatedItems
        title={intl.formatMessage(messages.possible_destinations)}
        items={content.relatedItems}
        background={true}
      />

      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default ItineraryView;
